import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { useState } from 'react'

type Props = {
  open?: boolean
  text?: string
  title?: string
  okButtonLabel?: string
  cancelButtonLabel?: string
  buttonLabel?: string
  onClose?: (ok: boolean) => void
  hideOkButton?: boolean
  hideCancelButton?: boolean
}

export function AlertDialog(props: Props) {
  const {
    open,
    text = '',
    title = 'Alerta!',
    okButtonLabel = 'confirmar',
    cancelButtonLabel = 'cancelar',
    buttonLabel,
    onClose,
    hideOkButton,
    hideCancelButton
  } = props
  const [isOpen, setOpen] = useState(!!open)

  console.log({ isOpen })

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = (ok: boolean) => {
    setOpen(false)
    onClose?.(ok)
  }

  return (
    <div>
      {buttonLabel && (
        <Button variant="outlined" onClick={handleClickOpen}>
          {buttonLabel}
        </Button>
      )}
      <Dialog
        open={isOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            style={{ whiteSpace: 'pre-line' }}
          >
            {text}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {!hideCancelButton && (
            <Button onClick={() => handleClose(false)}>
              {cancelButtonLabel}
            </Button>
          )}
          {!hideOkButton && (
            <Button onClick={() => handleClose(true)} autoFocus>
              {okButtonLabel}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </div>
  )
}
